import React from "react";
import AddAddress from "../components/Profile/AddAddress";
import { useNavigate } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";

const AddAddressPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);
  const customerUniqueCode = sessionStorage.getItem("Customer-vUniqueCode");
  const contractorUniqueCode = sessionStorage.getItem("Contractor-vUniqueCode");
  React.useEffect(() => {
    if (customerUniqueCode) {
      setLoading(false);
    } else if (contractorUniqueCode) {
      setLoading(false);
    } else {
      navigate("/login");
    }
  }, [customerUniqueCode, navigate, contractorUniqueCode]);

  if (loading) {
    return null;
  }

  return customerUniqueCode ? <AddAddress /> : <NotFoundPage />;
};

export default AddAddressPage;
